/** Wire-Werte der eingehenden E-Mails (Backend liefert sie als Text). Anzeige über i18n. */
export const APPOINTMENT_CHANGE_TYPE = {
  booking: "booking",
  confirmation: "confirmation",
  cancellation: "cancellation",
  reschedule: "reschedule",
  unclear: "unclear",
} as const;

export const REST_PERIOD_REQUEST_TYPE = {
  extension: "extension",
  new: "new",
} as const;

export const INBOUND_EMAIL_CONTRACT_STATUS = {
  active: "active",
  paused: "paused",
  cancelled: "cancelled",
  ended: "ended",
} as const;

export const INBOUND_EMAIL_RELEVANCE_VALUE = {
  irrelevant: "irrelevant",
} as const;

export const INBOUND_EMAIL_UNCLASSIFIED_FILTER_VALUE = "unclassified";

export const ATTACHMENT_EXTRACTION_STATUS = {
  queued: "queued",
  processing: "processing",
  completed: "completed",
  extracted: "extracted",
  pending: "pending",
  unsupported: "unsupported",
  failed: "failed",
} as const;

/** Prüfgründe; die Anlagen-Codes tragen ein Präfix, die präfixlosen Varianten stammen aus älteren Datensätzen. */
export const INBOUND_EMAIL_REVIEW_REASON = {
  modelNotConfigured: "model_not_configured",
  invalidModelOutput: "invalid_model_output",
  modelOutputTruncated: "model_output_truncated",
  modelProviderTimeout: "model_providertimeout",
  attachmentNeedsReview: "attachment_needs_review",
  personNotFound: "person_not_found",
  personAmbiguous: "person_ambiguous",
  contractNotFound: "contract_not_found",
  contractAmbiguous: "contract_ambiguous",
  otherServiceNeedsReview: "other_service_needs_review",
  classificationUncertain: "classification_uncertain",
  analysisFailed: "analysis_failed",
  attachmentTooLarge: "attachment_too_large",
  messageTooLarge: "message_too_large",
  rawMessageTooLarge: "raw_message_too_large",
  formatUnsupported: "format_unsupported",
  attachmentFormatUnsupported: "attachment_format_unsupported",
  ocrUnavailable: "ocr_unavailable",
  attachmentOcrUnavailable: "attachment_ocr_unavailable",
  corrupt: "corrupt",
  attachmentCorrupt: "attachment_corrupt",
  attachmentOcrFailed: "attachment_ocr_failed",
  attachmentTextEmpty: "attachment_text_empty",
  attachmentExtractedTextTooLarge: "attachment_extracted_text_too_large",
} as const;

export const REALTIME_REFRESH_DELAY_MS = 250;
export const MIN_PERSON_SEARCH_LENGTH = 2;
export const PERCENT_SCALE = 100;
